import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { anchorOptionsSelector } from '../../../common/store/selectors/anchorOptions.selector';
import { anchorDataSelector } from '../../../common/store/selectors/anchorData.selector';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../common/hooks/useStyles';
import { getCloseBarStyleObject } from './closeBar.style';
import { splitViewSelector } from '../../../common/store/selectors/splitView.selector';
import { CloseIcon } from '../../../common/components/closeIcon/closeIcon';
import { getCloseIconId, getContainerId } from '../htmlElements/htmlElementsGetter';
import { ErrorBoundary } from '../../../common/components/errorBoundary/errorBoundary';
import { Title } from '../title/title';
import { COMMON_ICON_TYPES } from '../../../common/components/icon/iconMapper';
import { css } from '../../../common/styles/styles.utils';
import { isEmpty } from '../../../common/utils/utils';

const CLOSE_BAR_PLUGIN = 'CloseBar';

const CloseBar: FunctionComponent = () => {
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const canClose = useSelector(anchorOptionsSelector.canClose);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const orientation = useSelector(anchorOptionsSelector.orientation);

  const isAnchored = anchorStatus === 'active';
  const showCloseBar = isAnchored && canClose && isEmpty(splitViewRatio);
  const stickyMode = orientation === 'sticky';
  const showCircleClose = !stickyMode && (playerSize === 'small' || playerSize === 'extraSmall');

  const styles = useStyles(getCloseBarStyleObject, [playerSize, stickyMode]);
  const { closeBarContainerStyle, closeIconStyle, circleCloseIconStyle, closeClickableWrapperStyle } = styles;

  const closeIconProps = {
    icon: COMMON_ICON_TYPES.CLOSE_FILL,
    style: closeIconStyle,
    wrapperStyle: closeClickableWrapperStyle,
    id: getCloseIconId(playerUniqueId),
    addClickableWrapper: true,
  };

  const circleCloseIconProps = {
    icon: COMMON_ICON_TYPES.CLOSE_CIRCLE,
    style: circleCloseIconStyle,
    id: getCloseIconId(playerUniqueId),
    addClickableWrapper: false,
  };

  const closeProps = showCircleClose ? circleCloseIconProps : closeIconProps;

  return (
    <ErrorBoundary pluginName={CLOSE_BAR_PLUGIN}>
      {
        showCloseBar ? (
          <div id={getContainerId(playerUniqueId)} style={css(closeBarContainerStyle)}>
            <Title />
            <CloseIcon {...closeProps} />
          </div>
        ) : null
      }
    </ErrorBoundary>
  );
};

export default CloseBar;
